import { AlignmentType, BorderStyle, HeadingLevel, ImageRun, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, TextWrappingSide, TextWrappingType, WidthType } from "docx";

export function disclaimerNetworkPage1(certInNetworkCustomerName) {
    return new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { before: 450, after: 300 },
    spacing:{line:276, after: 10 * 72 * 0.05},
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "This document is highly confidential and sensitive and is meant for circulation only to authorized people within"+" "+certInNetworkCustomerName+" "+"and ISECURION.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})}

export const disclaimerNetworkPage2 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line:276, before: 350, after: 300 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "This report is being supplied by us upon request and on the basis that no part of this document may be copied, disclosed, referred or duplicated in part or whole (except for your own internal purpose and to authorized signatories) in any form. It is also hereby assumed that you shall not quote our name or reproduce our logo or other trademarks in print or in any form or medium without our express acquiescence. You may disclose this report to your legal and other professional advisors for the purpose of your seeking advice in relation to the report and the data contained herein, provided that when doing so, it is understood that disclosure in part or full of the contents or any information derived from the report to unauthorized personnel is strictly prohibited.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})

export function disclaimerNetworkPage3(certInNetworkCustomerName) {
    return new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line:276, before: 350, after: 300 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "ISECURION has performed Vulnerability Assessment and Penetration Testing on the request of "+certInNetworkCustomerName+". The intent of which is to identify the existing vulnerabilities in the Web application and to explore the possibilities of these vulnerabilities may be exploited by malicious users, if not mitigated.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})}

export const disclaimerNetworkPage4 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line:276, before: 350, after: 300 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Any advice, opinion, remedial measures, forecast or recommendation provided by ISECURION in this report is based on the information provided to us and we believe such advice, opinion, remedial measures, forecast or recommendation to be valid. Due professional care has been taken by ISECURION during the execution of this exercise. ISECURION is not liable for any damage of any form caused directly or indirectly during and post completion of this exercise. ISECURION would not be accountable for the outcome of implementing any of the recommendations contained herein.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})

export const disclaimerNetworkPage5 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line:276, before: 350, after: 300 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The data contained in this report does not amount to guarantee that we have predicted future events or circumstances but shall ensure accuracy, competency, correctness or completeness of the report based on the information provided to us. This exercise has been undertaken within a given time period in a comprehensive manner. ISECURION cannot guarantee security of the target site, though mitigation of the findings can substantially reduce the risks of a security breach.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})
